import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input()
  text = '';

  ngOnInit(): void {
    //Disable all input events while loader is showing
    document.addEventListener('keydown', this.preventHandler, true);
    document.addEventListener('click', this.preventHandler, true);
  }

  preventHandler(event: any) {
    //Allow input events on anchor tags (for NX rewards in particular)
    const anchorHref = (event.target as HTMLAnchorElement)?.href;

    if (anchorHref) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    //Re-enable all input events when loader is hidden
    document.removeEventListener('keydown', this.preventHandler, true);
    document.removeEventListener('click', this.preventHandler, true);
  }
}
